import styled from "styled-components";

interface IButton {
  name?: any;
  IconLeft?: any;
  Icon?: any;
  onClick?: () => void;
  type?: "button" | "submit" | "reset"; // Tipos de botão válidos
}

export default function ActionButton({
  name,
  IconLeft,
  Icon,
  onClick,
  type = "button",
}: IButton) {
  return (
    <Container type={type} onClick={onClick}>
      {IconLeft && IconLeft}
      {name && <p>{name}</p>}
      {Icon}
    </Container>
  );
}

const Container = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  border-radius: 8px;
  padding: 8px 16px;
  
  color: ${(props) => props.theme.colors.white};
  background-color: ${(props) => props.theme.colors.primary};

  font-weight: 500;
  font-size: 16px;
  white-space: nowrap;

  &:hover {
    background-color: ${(props) => props.theme.colors.red.red_800};
  }
`;
